export const redWords: Record<string, string> = {
  "Attach": "Detail, Outline",
  "Attached": "Detailed, Outlined",
  "Attaching": "Detailing, Outlining",
  "Attaches": "Details, Outlines",
  "Availability": "Scope, Posture, Appropriateness, Suitability",
  "Available": "Within the scope or posture, Appropriate, Suitable",
  "Unavailable": "Not within the scope, Not suitable, Not appropriate",
  "Billing": "Economic Statement, Economic Charges",
  "Bill": "Economic Charge, Economic Statement",
  "Bills": "Economic Charges, Economic Statements",
  "Billed": "Charged",
  "Budget": "Reserves, Resources, Allocation",
  "Calendar": "Scope, posture, appropriateness, suitability",
  "Calendars": "Scopes, postures, appropriateness, suitability",
  "Chron": "Summary, Summarization",
  "Chronicle": "Summary, Summarization",
  "Chronicles": "Summaries, Summarizations",
  "Close": "Finalize",
  "Closing": "Finalizing",
  "Closes": "Finalizes",
  "Closed": "Finalized",
  "Compile": "Review and simultaneously identify",
  "Compiling": "Reviewing and simultaneously identifying",
  "Compiles": "Reviews and simultaneously identifies",
  "Compiled": "Reviewed and simultaneously identified",
  "Confirm": "Substantiate, Authenticate, Corroborate, Validate",
  "Confirmed": "Substantiated, Authenticated, Corroborated, Validated",
  "Confirms": "Substantiates, Authenticates, Corroborates, Validates",
  "Confirming": "Substantiating, Authenticating, Corroborating, Validating",
  "Confirmation": "Substantiation, Authentication, Corroboration, Validation",
  "Court Docket": "Court Record, Court Summary",
  "Court Dockets": "Court Records, Court Summaries",
  "Data": "Facts, Details, Particulars, Specifics",
  "Docket": "Court Record, Court Summary",
  "Dockets": "Court Records, Court Summaries",
  "Deadline": "Mandate",
  "Deadlines": "Mandates",
  "Enclosed": "Briefly outlining details of",
  "Enclosing": "Briefly outlining details of",
  "Enclose": "Briefly outline details of",
  "Enclosure": "Briefly outlined details of",
  "Enclosures": "Briefly outlined details of",
  "Following up": "Assessing current posture",
  "Follows up": "Assesses current posture",
  "Follow-up": "Assess current posture",
  "Follow-ups": "Assessments of current postures",
  "Followed up": "Assessed current posture",
  "Forward": "Briefly outline details of",
  "Forwarding": "Briefly outlining details of",
  "Forwards": "Briefly outlines details of",
  "Forwarded": "Briefly outlined details of",
  "Invoice": "Economic Statement, Economic Charges",
  "Invoices": "Economic Statements, Economic Charges",
  "Invoicing": "Detailing Economic Charges",
  "Look up": "Examine, Research",
  "Looked up": "Examined, Researched",
  "Looking up": "Examining, Researching",
  "Matrix": "Summary, Summarization",
  "Matrices": "Summaries, Summarizations",
  "Online Docket": "Court Record, Court Summary",
  "Online Dockets": "Court Records, Court Summaries",
  "Potential Date": "Discuss Scope, Posture, Parameters of",
  "Potential Dates": "Discuss Scopes, Postures, Parameters of",
  "Prepare Exhibit": "Review and simultaneously identify key and pertinent exhibits",
  "Prepares Exhibit": "Reviews and simultaneously identifies key and pertinent exhibits",
  "Prepared Exhibit": "Reviewed and simultaneously identified key and pertinent exhibits",
  "Preparing Exhibit": "Reviewing and simultaneously identifying key and pertinent exhibits",
  "Prepared Exhibits": "Reviewed and simultaneously identified key and pertinent exhibits",
  "Proposed Date": "Scope, Posture, Appropriateness, Suitability",
  "Proposed Dates": "Scopes, Postures, Appropriateness, Suitability",
  "Providing": "Briefly outlining details of",
  "Provides": "Briefly outlines details of",
  "Provided": "Briefly outlined details of",
  "Redact": "Review and simultaneously identify privileged and confidential information",
  "Redacting": "Reviewing and simultaneously identifying privileged and confidential information",
  "Redacts": "Reviews and simultaneously identifies privileged and confidential information",
  "Redacted": "Reviewed and simultaneously identified privileged and confidential information",
  "Redaction": "Reviewed and simultaneously identified privileged and confidential information",
  "Redactions": "Reviewed and simultaneously identified privileged and confidential information",
  "Re-Setting": "Discussing Scope, Posture, Appropriateness, Suitability",
  "Re-Set": "Discussed Scope, Posture, Appropriateness, Suitability",
  "Re-Sets": "Discusses Scope, Posture, Appropriateness, Suitability",
  "Retrieve": "Review, Identify",
  "Retrieves": "Reviews, Identifies",
  "Retrieved": "Reviewed, Identified",
  "Retrieving": "Reviewing, Identifying",
  "Revise": "Supplement, Amend",
  "Revises": "Supplements, Amends",
  "Revised": "Supplemented, Amended",
  "Revising": "Supplementing, Amending",
  "Revision": "Supplement, Amendment",
  "Revisions": "Supplements, Amendments",
  "Reschedule": "Discuss Scope, Posture, Appropriateness, Suitability",
  "Reschedules": "Discusses Scopes, Postures, Appropriateness, Suitability",
  "Rescheduled": "Discussed Scope, Posture, Appropriateness, Suitability",
  "Renotify": "Discuss Scope, Posture, Appropriateness, Suitability",
  "Renotification": "Discuss Scope, Posture, Appropriateness, Suitability",
  "Schedule": "Discuss Scope, Posture, Appropriateness, Suitability",
  "Schedules": "Discusses Scopes, Postures, Appropriateness, Suitability",
  "Scheduled": "Discussed Scope, Posture, Appropriateness, Suitability",
  "Scheduling": "Discussing Scope, Posture, Appropriateness, Suitability",
  "Setting": "Scope, Posture, Appropriateness, Suitability",
  "Settings": "Scopes, Postures, Appropriateness, Suitability",
  "Status of": "Posture, Position, Condition",
  "Statuses of": "Postures, Positions, Conditions",
  "Strategize": "Review, Analyze, Assess",
  "Strategizes": "Reviews, Analyzes, Assesses",
  "Strategized": "Reviewed, Analyzed, Assessed",
  "Strategizing": "Reviewing, Analyzing, Assessing",
  "Strategy": "Review, Analysis, Assessment",
  "Strategies": "Reviews, Analyses, Assessments",
  "Suggested Date": "Scope, Suitability",
  "Suggested Dates": "Scopes, Suitability",
  "Unorganized": "Dense, Poor Quality, Incoherent Material",
  "W9": "Obtain provider information according to IRS",
  "W-9": "Obtain provider information according to IRS",
  "Zip Drive": "Review and identify simultaneously",
  "Zip Drives": "Review and identify simultaneously",
};

export interface RedWordMatch {
  word: string;
  suggestion: string;
  startIndex: number;
  endIndex: number;
}

export const detectRedWords = (text: string): RedWordMatch[] => {
  const matches: RedWordMatch[] = [];
  const lowerText = text.toLowerCase();
  
  Object.entries(redWords).forEach(([redWord, suggestion]) => {
    const lowerRedWord = redWord.toLowerCase();
    let startIndex = 0;
    
    while (true) {
      const index = lowerText.indexOf(lowerRedWord, startIndex);
      if (index === -1) break;
      
      // Check if it's a whole word (not part of another word)
      const prevChar = index > 0 ? lowerText[index - 1] : ' ';
      const nextChar = index + lowerRedWord.length < lowerText.length 
        ? lowerText[index + lowerRedWord.length] : ' ';
      
      const isWholeWord = /\W/.test(prevChar) && /\W/.test(nextChar);
      
      if (isWholeWord) {
        matches.push({
          word: text.substring(index, index + lowerRedWord.length),
          suggestion,
          startIndex: index,
          endIndex: index + lowerRedWord.length,
        });
      }
      
      startIndex = index + 1;
    }
  });
  
  // Sort by start index to maintain order
  return matches.sort((a, b) => a.startIndex - b.startIndex);
};

export const hasRedWords = (text: string): boolean => {
  return detectRedWords(text).length > 0;
};